<template>
    <div>
        <v-card>
            <v-card-text>
                <v-card-title class="titulopagina">NUMERO FOLIO DE ACEITE</v-card-title>
            </v-card-text>
            <v-card-text>
                <v-row>
                    Seleccione el ´    <v-checkbox color="info" class="sin-padd" hide-details></v-checkbox> ´   del bloque que desee buscar filas sin número de folio, se habilitarán las opciones para poder usar filtro de fechas ... luego haga click en buscar
                </v-row>
                <v-row>
                    <v-col cols="2" :class="`${opcion === 'planta' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="orange">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="planta" class="pt-0" color="orange" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Producción Planta </b></span>
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Elaboración: </label>
                                    <date-picker :disabled="opcion !== 'planta'" v-model="produccion.fecha_prod" range-separator="|" range placeholder="Fecha Producción" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="2"  :class="`${opcion === 'romana' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="blue">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="romana" class="pt-0" color="blue" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Despachos Romana</b></span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Despacho: </label>
                                    <date-picker :disabled="opcion !== 'romana'" v-model="romana.fecha_romana" range-separator="|" range placeholder="Fecha Despacho" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="2" :class="`${opcion === 'bodegas' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="green">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="bodegas" class="pt-0" color="green" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Recepción Bodegas</b></span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Recepcion: </label>
                                    <date-picker :disabled="opcion !== 'bodegas'" v-model="bodegas.fecha_bodega" range-separator="|" range placeholder="Fecha Recepción" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="2" :class="`${opcion === 'ventas' ? `back-${opcion}` : 'sin-back'}`">
                        <v-alert outlined color="gray">
                            <v-row>
                                <v-col cols="2">
                                    <v-checkbox v-model="opcion" value="ventas" class="pt-0" color="gray" hide-details ></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <span class="text-center"><b> Exportación / Venta</b></span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0 pl-2 pr-2">
                                    <label>Fecha Embarque: </label>
                                    <date-picker :disabled="opcion !== 'ventas'" v-model="ventas.fecha_embarque" range-separator="|" range placeholder="Fecha Embarque" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>

                    <v-col cols="3">
                        <v-row>
                            <v-col cols="12" v-if="(opcion == 'planta') || (opcion == 'romana') || opcion == 'bodegas'">
                                <v-checkbox 
                                            v-model="folios_vacios" 
                                            label="Sólo folios vacíos" 
                                            class="pt-0 mb-6" 
                                            color="blue" 
                                            hide-details 
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" v-if="(opcion == 'romana') || opcion == 'ventas'">
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-btn dark color="blue darken-1" class="mb-4" @click="cargar_traza"><v-icon>search</v-icon> Buscar</v-btn>
                        </v-row>
                        
                        <pre class="mb-4">filtro {{this.opcion}}</pre>

                    </v-col>
                </v-row>
            </v-card-text>
            <div class="table-wrap">
                <v-simple-table
                    fixed-header
                    width="100%"
                    height="90vh"
                >
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-center cabecera" colspan="8"> Producciones </th>
                            <th class="text-center cabecera" colspan="6"> Despachos - Mermas </th>
                            <th class="text-center cabecera" colspan="7"> Recepciones </th>
                            <th class="text-center cabecera" colspan="20"> Exportaciones - Ventas </th>

                        </tr>
                        <tr>
                            <th class="text-center cabecera">
                                Fecha Elaboración
                            </th>
                            <th class="text-center cabecera">
                                Folio Producción
                            </th>
                            <th class="text-center cabecera">
                                Cantidad
                            </th>
                             <th class="text-center cabecera">
                                Stock
                            </th>
                            <th class="text-center cabecera">
                                Línea
                            </th>
                            <th class="text-center cabecera m200" >
                                Proceso
                            </th>
                            <th class="text-center cabecera">
                                Estanque
                            </th>
                            <th class="text-center cabecera">
                                Observación
                            </th>
                            <th class="text-center cabecera">
                                Fecha Despacho
                            </th>
                            <th class="text-center cabecera">
                                Guía Despacho
                            </th>
                            <th class="text-center cabecera">
                                Ticket
                            </th>
                            <th class="text-center cabecera">
                                Folio Destino
                            </th>
                            <th class="text-center cabecera m160">
                                Lugar Destino
                            </th>
                            <th class="text-center cabecera">
                                Cant. Despacho
                            </th>
                            <th class="text-center cabecera">
                                Fecha Abastecim.
                            </th>
                            <th class="text-center cabecera">
                                Folio Abastecim.
                            </th>
                            <th class="text-center cabecera">
                                Estanque Destino
                            </th>
                            <th class="text-center cabecera m140">
                                Lote Destino
                            </th>
                            <th class="text-center cabecera">
                                Cant. Recepción
                            </th>
                            <th class="text-center cabecera">
                                Stock
                            </th>
                            <th class="text-center cabecera">
                                Observación
                            </th>
                            <th class="text-center cabecera">
                                Fecha Embarque
                            </th>
                            <th class="text-center cabecera">
                                Nro. Embarque
                            </th>
                            <th class="text-center cabecera">
                                Guía Embarque
                            </th>
                            <th class="text-center cabecera">
                                Cant. Embarque
                            </th>
                            <th class="text-center cabecera">
                                Bodega Destino
                            </th>
                            <th v-for="item in cabeceras" :key="item.id" class="text-center cabecera">
                                {{item.documento}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="fila,idx in filitas" :key="idx">
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.fecha }}</td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" > <v-text-field class="inputcito" v-if="fila.id_pt" v-model="fila.folio_prod" @change="set_folio('prod',fila.id_pt, fila.folio_prod)" dense hide-details="auto"></v-text-field> </td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.produccion }}</td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.stock }}</td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.linea }}</td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.tipo_mp }}</td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.estanque }}</td>
                            <td v-if="fila.filas_d > 0" :rowspan="`${fila.filas_d}`" :class="fila.clase" >{{ fila.obs_aceite }}</td>

                            <td v-if="fila.filas_r > 0" :rowspan="`${fila.filas_r}`" :class="fila.clase" >{{ fila.fecha_desp }}</td>
                            <td v-if="fila.filas_r > 0" :rowspan="`${fila.filas_r}`" :class="fila.clase" >{{ fila.guia_desp }}</td>
                            <td v-if="fila.filas_r > 0" :rowspan="`${fila.filas_r}`" :class="fila.clase" >{{ fila.ticket }}</td>
                            <td v-if="fila.filas_r > 0" :rowspan="`${fila.filas_r}`" :class="fila.clase" > <v-text-field class="inputcito" v-if="fila.id_dp" v-model="fila.folio_destino" @change="set_folio('desp',fila.id_dp, fila.folio_destino)" dense hide-details="auto"></v-text-field> </td>
                            <td v-if="fila.filas_r > 0" :rowspan="`${fila.filas_r}`" :class="fila.clase" >{{ fila.bodega_desp }}</td>
                            <td v-if="fila.filas_r > 0" :rowspan="`${fila.filas_r}`" :class="fila.clase" >{{ fila.cantidad }}</td>

                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" >{{ fila.fecha_rec }}</td>
                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" > <v-text-field class="inputcito" v-if="fila.id_r" v-model="fila.folio_abastecimiento" @change="set_folio('rec',fila.id_r, fila.folio_abastecimiento)" dense hide-details="auto"></v-text-field> </td>
                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" >{{ fila.tk_e }}</td>
                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" >{{ fila.lote_e }}</td>
                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" >{{ fila.litros }}</td>
                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" >{{ fila.stock_b }}</td>
                            <td v-if="fila.filas_v > 0" :rowspan="`${fila.filas_v}`" :class="fila.clase" >{{ fila.observacion }}</td>

                            <td :class="fila.clase" >{{ fila.fecha_vta }}</td>
                            <td :class="fila.clase" >{{ fila.nro_embarque }}</td>
                            <td :class="fila.clase" >{{ fila.guia_vta }}</td>
                            <td :class="fila.clase" >{{ fila.cant_vta }}</td>
                            <td :class="fila.clase" >{{ fila.bodega_vta }}</td>

                            <td v-for="item in cabeceras" :key="item.id">
                                {{ fila[item.id]  || '' }}
                            </td>
                        </tr>
                    </tbody>
                </template>
                </v-simple-table>
            </div>
            <modal-comentar-traza></modal-comentar-traza>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import DatePicker from 'vue2-datepicker';
import Modal_Comentar_Traza from '@/components/shared/Modal_Comentar_Traza.vue';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    data:() => ({
        opcion:'planta',
        folios_vacios:true,
        produccion:{
            fecha_prod:'',
        },
        romana:{
            fecha_romana:'',
        },
        bodegas:{
            fecha_bodega:'',
        },
        ventas:{
            fecha_embarque:'',
        },
        datos: [],
        estanques_ext:[],
        bodegas_destino: [],
        estanques:[],
        cabeceras:[],
        url:'',
        url_excel: ''
    }),
    mounted(){
        this.fecha =  this.moment().format('YYYY-MM-DD');
        this.cargarBodegas();
        this.cargarEstanquesExternos();
        this.cargarEstanques();
    },
    methods:{
        async cargarBodegas(){
            this.mostrarLoading({titulo:'Cargando bodegas...',color:'green'})
            let url = `${this.base_url}bodegas?tipo_produccion_id=2`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas_destino = res.data.data;
                this.bodegas_destino.unshift({id:'', nombre:''})
                this.ocultarLoading();
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar bodegas ");
                console.log('error',error);
            });
        },
        async cargarEstanquesExternos(){
            this.mostrarLoading({titulo:'Cargando estanques externos...',color:'green'})
            let url = `${this.base_url}estanques_externos/0`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques_ext = res.data.data;
                this.estanques_ext.unshift({id:'', nombre_corto:''})
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.errorMessage(error, "Error al cargar estanques externos ");
            });
        },
        async cargarEstanques(){
            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.estanques = response.data.data;
                this.estanques.unshift({id:'', codigo:''})
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar estanques ");
            });
        },
        async cargar_traza(){
            this.mostrarLoading({titulo:'Buscando Información...',color:'green'});
            let body = {}
            if (this.opcion == 'planta') {
                body = this.produccion
            } else if (this.opcion == 'romana') {
                body = this.romana
            } else if (this.opcion == 'bodegas') {
                body = this.bodegas
            } else if (this.opcion == 'ventas') {
                body = this.ventas
            }
            if (this.folios_vacios) {
                body.folios_vacios = 1
            } else {
                body.folios_vacios = 0
            }
            body.opcion = this.opcion
            console.log("body", body);
            // let fecha_ini = this.fecha[0];
            // let fecha_fin = this.fecha[1];
            let url = `${this.base_url}reporte_aceites`;
            await this.axios.post(url, body, this.headers).then((res) =>{
                this.datos = res.data.info;
                this.cabeceras = res.data.mov_docs;
                this.url_excel = res.data.url_excel;
            }).catch((e)=>{
                console.log(e);
                this.errorMessage(e, "Error al cargar estanques ");
            });
            this.ocultarLoading();
        },
        async set_folio(tipo, id, valor) {

            console.log(tipo, "tipo", id, "valor", valor)
            if(!tipo || !id || !valor ) return;
            this.mostrarLoading({titulo:'Grabando Folio...',color:'green'});
            let url = `${this.base_url}aceites/grabar_folios`;
            let body = {
                tipo: tipo,
                id: id,
                valor: valor
            }
            await this.axios.post(url, body, this.headers).then((res)=>{
                console.log(res.data.data);
                this.ocultarLoading();
            }).catch((e)=>{
                console.log(e);
                this.ocultarLoading();
                this.errorMessage(e, "Error al grabar folio ");
            });
        },
        exportarExcel(){
            console.log('url_excel',this.url_excel);
            let url = this.download_url.replace('bitacoras', 'formatos/aceites/') 
            window.location.href = url + this.url_excel;
        },
        async grabar_incremento(d, f){
            let url = `${this.base_url}despachos_harina/grabar/incremento`;
            if(typeof d[f] == "boolean") d[f] = d[f] == true ? 1:0;
            let body = {
                despacho_pts_id: d.id,
                incremento: d.incremento,
                campo: f,
                valor: d[f]
            }
            await this.axios.post(url, body, this.headers).then((res)=>{
                console.log(res.data.data);
            }).catch((e)=>{
                console.log(e);
            });
        },
        abrirModalComentario(registro){
            console.log('registro', registro);
            Event.$emit('abrir_modal_comentar_traza',registro);
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        filitas(){
            let arr = [];
            this.datos.forEach( (fila,idx) => { // producciones
                fila.despachos.forEach((desp,d) => {
                    desp.recepciones.forEach((rec,r) => {
                        rec.ventas.forEach((vta,v) => {
                            let arr1 = JSON.parse(JSON.stringify(fila)) ;
                            arr1.despachos = ''
                            arr1.clase = (idx % 2) == 0 ? 'cebrita' : ''
                            arr1.filas_d = ((v > 0) || (r > 0) || (d > 0)) ? 0 : fila.filas_d

                            let arr2 = JSON.parse(JSON.stringify(desp)) ;
                            arr2.recepciones = ''
                            arr2.filas_r = ((v > 0) || (r > 0)) ? 0 : desp.filas_r

                            let arr3 = JSON.parse(JSON.stringify(rec)) ;
                            arr3.ventas = ''
                            arr3.filas_v = (v > 0) ? 0 : rec.filas_v

                            const toReturn = Object.assign( arr1, arr2, arr3, vta)
                            arr.push(toReturn)
                        })
                    })
                })
            })
            return arr;
        },
        ...mapState(['base_url', 'user', 'headers', 'download_url']),
    },
    components:{
        DatePicker,
        'modal-comentar-traza':Modal_Comentar_Traza
    }
}
/* function setFolio(){

 }*/
</script>

<style scoped>
    td{padding: 0em 1em; border-bottom:1px solid #01579B !important;}
    .td2{border-left:1px solid #01579B !important;}
    .fila_r{background-color: #b2dfdb;}
    .table-wrap {width: 100%;  overflow-x: auto;  }
    .tablet>thead>tr>th {background-color: white; position: sticky; position: -webkit-sticky; top: 0; z-index: 2;} 
    .mx-datepicker{width: 100%!important;}
    .cebrita{background-color: #c5d1d7f0 !important;}
    .centrado{text-align:center !important; vertical-align:middle !important;}
    .v-data-table td { font-size: 0.875rem; height: 30px; }
    .m100{min-width: 100px!important;} .m120{min-width: 120px!important;} .m140{min-width: 140px!important;} .m160{min-width: 160px!important;} .m180{min-width: 180px!important;} .m200{min-width: 200px!important;}
    .back-planta{background-color:#FFF3E0;}
    .back-romana{background-color: #E1F5FE;}
    .back-bodegas{background-color: #E8F5E9;}
    .back-ventas{background-color: #F5F5F5;}
    .sin-back{background-color: transparent}
    .sin-padd{margin: -5px;}
    .inputcito{background-color: beige; border: 1px solid purple; text-align: center;}
</style>
